/**
 * Modal / toast title strings shared across the admin panel.
 * Matches Angular dialogService.confirm titles and legacy Validation Message modals.
 */
export const NOTIFICATION_TITLES = {
  success: 'Success',
  error: 'Validation Message',
  warning: 'Warning',
  info: 'Information',
  missingFields: 'Missing Fields',
} as const

export type NotificationTitle = (typeof NOTIFICATION_TITLES)[keyof typeof NOTIFICATION_TITLES]
